/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'inspector';
import { BlogListResponse, BlogResponse } from 'services/models/blog.models';

export interface PostComment {
  aid: string | number,
  name: string,
  email: string,
  comment: string
}

export interface PutLikes {
  aid: string | number
}

export const blogApi = createApi({
  reducerPath: 'blogQuery',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_ENDPOINT }),
  endpoints: (builder) => ({
    getList: builder.query<BlogListResponse, { items: number | string }>({
      query: ({ items }) => `articles/${items}`,
    }),
    getBlog: builder.query<BlogResponse, { id: number | string }>({
      query: ({ id }) => `article/${id}`
    }),
    postComment: builder.mutation<{}, PostComment>({
      query({aid, email, name, comment}) {
        return {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          url: `article/${aid}/comment`,
          body: new URLSearchParams({aid: aid.toString(), email, name, comment})
        }
      }
    }),
    submitLikes: builder.mutation<{}, PutLikes>({
      query({aid}) {
        return {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          url: `article/${aid}/like`
        }
      }
    })
  }),
})

export const {
  useGetListQuery,
  useGetBlogQuery,
  usePostCommentMutation,
  useSubmitLikesMutation,
  util: { getRunningQueriesThunk, getRunningMutationsThunk },
} = blogApi;

export const { getList, getBlog, postComment, submitLikes } = blogApi.endpoints;